export default __webpack_public_path__ + "static/icon2@2x-70c2ab4d61d797af46ebd2ec23718abe.png";